import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';

import * as appActions from '../../../app/App/actions';
import * as appSelectors from '../../../app/App/selectors';

export const shouldBlacklist = ({ whiteListOptions, mockUpdatedLocation }) => {
  let blackList = true;
  const updatedLocation = mockUpdatedLocation || window.location.href;
  // eslint-disable-next-line no-restricted-syntax
  for (const whiteList of whiteListOptions) {
    const operator = get(whiteList, 'website_url.operator');
    const equalsOperator = operator === 'equals';
    const notEqualsOperator = operator === 'not_equals';
    const containsOperator = operator === 'contains';
    const notContainsOperator = operator === 'not_contains';
    const whiteListValue = get(whiteList, 'website_url.value');
    if (containsOperator && includes(updatedLocation, whiteListValue)) {
      blackList = false;
      break;
    }
    if (notContainsOperator && !includes(updatedLocation, whiteListValue)) {
      blackList = false;
      break;
    }
    if (equalsOperator && updatedLocation === whiteListValue) {
      blackList = false;
      break;
    }
    if (notEqualsOperator && updatedLocation !== whiteListValue) {
      blackList = false;
      break;
    }
  }
  return blackList;
};

export const checkWhiteList = ({ whiteListOptions, dispatch, getState, mockUpdatedLocation }) => {
  const state = getState();
  const route = appSelectors.getCurrentAppRoute(state);

  const chatOpen = route === 'app';
  const blackList = shouldBlacklist({ whiteListOptions, mockUpdatedLocation });

  if (blackList && !chatOpen) {
    dispatch(appActions.setAppBlackList({ value: true }));
  } else if (!chatOpen) {
    dispatch(appActions.setAppBlackList({ value: false }));
  }
};

export const whiteListListener = ({ whiteListOptions, store }) => () => {
  setTimeout(() => {
    const dispatch = store.dispatch;
    const getState = store.getState;
    checkWhiteList({ whiteListOptions, getState, dispatch });
  }, 0);
};

export const addWhiteListListeners = ({ whiteListOptions, store }) => {
  if (!isEmpty(whiteListOptions)) {
    try {
      history.onpushstate = whiteListListener({ whiteListOptions, store });
      window.onpopstate = whiteListListener({ whiteListOptions, store });
    } catch (err) {
      // eslint-disable-next-line
      console.log('error adding white list listeners', err);
    }
  }
};
